import React from "react"
//import components
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import InvoiceablesTable from "./InvoiceablesTable"
import { useTranslation } from "react-i18next"

export default function InvoiceablesList() {

  const { t } = useTranslation()
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Invoiceables")} />
        <InvoiceablesTable />
      </div>
    </div>
  )
}
